import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import API from "@/api";
import {
  Button,
  Col,
  Empty,
  Flex,
  Form,
  Input,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Tag,
} from "antd";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";
import "./index.less";
import GyRightArrow from "../../../../assets/images/gyRightArrow.svg";

function GyfxData(props) {
  const { question_id, wideTableRef, slots, rootSlots } = props;
  const [data, setData] = useState({});
  const [spinning, setSpinning] = useState(true);
  const [gySpining, setGySpining] = useState(true);
  const [gyfxData, setGyfxData] = useState("");
  const [init, setInit] = useState(false);
  const [zyyxysData, setZyyxysData] = useState([]);
  const [glsjData, setGlsjData] = useState([]);
  const [suggestionData, setSuggestionData] = useState([]);
  const formRef = useRef();
  console.log("wideTableRef====", wideTableRef);
  useEffect(() => {
    getGyfx({}, false);
  }, []);

  const getGyfx = (val, bol) => {
    axios
      .post(API.gyfx, {
        question_id: question_id,
        // wide_table_ref: wideTableRef?.[0] || "",
        // runtime_message_meta: {
        //   wide_table_refs: wideTableRef,
        //   root_slots: rootSlots,
        //   slots: slots,
        // },
        ...val,
      })
      .then((res) => {
        const data = res?.data?.data || {};
        setData(data);
        setSpinning(false);
        console.log(res);
        if (bol) {
          setInit(true);
          setZyyxysData(res?.data?.data?.attribution_cards);
        }
      });
  };

  const handleStreamRequest = async (val) => {
    const url = API.getGyDetail;
    const payload = {
      question_id: question_id,
      // wide_table_ref: wideTableRef?.[0] || "",
      // runtime_message_meta: {
      //   wide_table_refs: wideTableRef,
      //   root_slots: rootSlots,
      //   slots: slots,
      // },
      ...val,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 如果需要鉴权
          // 'Authorization': 'Bearer token'
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      setInit(true);
      setTimeout(() => {
        setGySpining(false);
      }, 500);
      // 1. 获取读取器
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let resultText = "";

      // 2. 循环读取流
      while (true) {
        const { done, value } = await reader.read();
        if (done) break; // 读取完毕

        // 3. 解码二进制数据
        const chunk = decoder.decode(value, { stream: true });
        // chunk 可能是多行数据，需要按换行符分割
        const lines = chunk.split("\n");
        lines.forEach((line) => {
          if (line.trim().startsWith("data:")) {
            // 去掉 'data:' 前缀
            const jsonString = line.replace(/^data:/, "").trim();
            if (jsonString === "[DONE]") return; // 结束标志

            try {
              const json = JSON.parse(jsonString);
              // 4. 提取增量内容 (delta) 并追加到结果中
              if (json?.data?.status && json?.data?.status === "done") {
                console.log(json.data);
                setZyyxysData(
                  json?.data?.payload?.attribution_cards?.impact_factors,
                );
                setGlsjData(
                  json?.data?.payload?.attribution_cards?.related_evidence,
                );
                setSuggestionData(
                  json?.data?.payload?.attribution_cards?.recommendations ||
                    json?.data?.payload?.suggestions,
                );
              }
              if (json.data && json.data.delta) { 
                resultText += json.data.delta;
                // 更新页面显示 (例如 React 的 setState)
                setGyfxData(resultText);
              }
            } catch (e) {
              console.error("解析 JSON 失败:", e);
            }
          }
        });
      }
    } catch (error) {
      console.error("请求失败:", error);
    }
  };

  return (
    <div className="gyfx">
      <div className="gyset">
        <Spin spinning={spinning}>
          <div className="action">
            <Flex justify="space-between" align="center">
              <div className="title">归因设置</div>
              <div className="btn">
                <Button
                  type="primary"
                  onClick={() => {
                    const data = formRef.current?.getFieldsValue();
                    getGyfx(data, true);
                    handleStreamRequest(data);
                    setInit(false);
                    setGySpining(true);
                  }}
                >
                  开始分析
                </Button>
              </div>
            </Flex>
          </div>
          <div className="searchContent">
            {!spinning ? (
              <Form
                ref={formRef}
                initialValues={{
                  attribution_date: data?.resolved_config?.attribution_date,
                  compare_date: data?.resolved_config?.compare_date,
                  metric_field: data?.resolved_config?.metric_field,
                  date_field: data?.resolved_config?.date_field,
                }}
              >
                <Row gutter={[16, 0]}>
                  <Col span={12}>
                    <Form.Item name="metric_field" label="归因指标">
                      <Select
                        options={[
                          {
                            label: data?.resolved_config?.metric_label,
                            value: data?.resolved_config?.metric_field,
                          },
                        ]}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="date_field" label="日期字段">
                      <Select
                        options={[
                          {
                            label: data?.resolved_config?.date_label,
                            value: data?.resolved_config?.date_field,
                          },
                        ]}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="归因日期" name="attribution_date">
                      <Select
                        options={(data?.available_dates || []).map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        })}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="对比日期" name="compare_date">
                      <Select
                        options={(data?.available_dates || []).map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        })}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            ) : undefined}
          </div>
        </Spin>
      </div>
      {init ? (
        <div className="wrapContent">
          <Spin spinning={gySpining}>
            <div className="indicator">
              <div className="title">指标概况</div>
              <div className="indicatorContent">
                <Flex justify="space-evenly" align="center">
                  <div className="listItem">
                    <div className="value">{data?.overview?.compare_value}</div>
                    <div className="time">
                      {data?.resolved_config?.compare_date}
                    </div>
                  </div>
                  <div>
                    <img
                      style={{
                        width: "120px",
                        height: "30px",
                      }}
                      src={GyRightArrow}
                      alt=" "
                    />
                  </div>
                  <div className="listItem">
                    <div className="value">{data?.overview?.current_value}</div>
                    <div className="time">
                      {data?.resolved_config?.attribution_date}
                    </div>

                    <span className="delta_rate">
                      <Tag
                        color={
                          data?.overview?.delta_rate * 1 > 0
                            ? "error"
                            : "success"
                        }
                      >
                        {data?.overview?.delta_rate_text}
                      </Tag>
                    </span>
                  </div>
                </Flex>
              </div>
            </div>
            <div className="gyContent">
              <div className="title">归因结论</div>
              <div className="gyMarkDownContent">
                <Markdown
                  data={{
                    think: null,
                    thinking: false,
                    content: gyfxData,
                  }}
                ></Markdown>
              </div>
            </div>
            <div className="zyyxys">
              <div className="title">主要影响因素</div>
              <div className="yxysContent">
                {zyyxysData && zyyxysData.length ? (
                  <>
                    <Row gutter={[16, 16]}>
                      {zyyxysData.map((item) => {
                        return (
                          <Col span={12}>
                            <div key={item.rank} className="yxysItem">
                              <div className="rank">
                                <span className="top">
                                  <span className="text">Top</span>
                                  <span className="sort">{item.rank}</span>
                                </span>
                                <span className="relation">
                                  {item.relation}
                                </span>
                              </div>
                              <div className="titleText">{item.title}</div>
                              <div className="subtitle">{item.subtitle}</div>
                              <div className="items">
                                <Row gutter={[16, 16]}>
                                  <Col span={8}>
                                    <div className="itemList">
                                      <div className="dTitle">贡献变化</div>
                                      <div className="sub">
                                        {item.delta || ""}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col span={8}>
                                    <div className="itemList">
                                      <div className="dTitle">贡献占比</div>
                                      <div className="sub">
                                        {item.contribution_ratio || ""}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col span={8}>
                                    <div className="itemList">
                                      <div className="dTitle">显著性</div>
                                      <div className="sub">
                                        {item.significance_label || ""}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                              <div className="des">{item.description}</div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : (
                  <Empty />
                )}
              </div>
            </div>
            <div className="zyyxys">
              <div className="title">关联证据</div>
              <div className="glzjContent">
                {glsjData && glsjData.length ? (
                  <>
                    <Row gutter={[0, 16]}>
                      {glsjData.map((item) => {
                        return (
                          <Col span={24}>
                            <div className="glzjListItem">
                              <div className="glzjTitle">{item.title}</div>
                              <Space>
                                <div className="label">{item.metric_label}</div>
                                <div className="label">{item.relation}</div>
                                <div className="label">p={item.delta}</div>
                                <div className="label">
                                  {item.significance_label}
                                </div>
                              </Space>
                              <div className="des">{item.description}</div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : (
                  <Empty />
                )}
              </div>
            </div>
            <div className="zyyxys">
              <div className="title">建议方向</div>
              <div className="jyfxContent">
                {suggestionData && suggestionData.length ? (
                  <>
                    <ul className="suggestion">
                      {suggestionData.map((item) => {
                        return <li className="listItem">{item}</li>;
                      })}
                    </ul>
                  </>
                ) : (
                  <Empty />
                )}
              </div>
            </div>
          </Spin>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            // height: "calc(100% - 240px)",
            marginTop: "20px",
          }}
        >
          <Result
            status={undefined}
            icon={null}
            subTitle="请点击开始分析按钮"
          />
        </div>
      )}
    </div>
  );
}

export default GyfxData;
